import React from 'react';
import iconMap from 'icons/iconMap';
import warning from 'fbjs/lib/warning'

export default ({ icon, className }) => {
  const iconUrl = iconMap[icon];
  if (process.env.NODE_ENV === 'development') {
     warning(typeof iconUrl !== 'undefined', `No icon found for '${icon}'. Did you forget to add it to iconMap.js?`);
  }
  return <img src={iconUrl} alt={icon} className={className}/>
};


// WEBPACK FOOTER //
// ./src/components/common/Icon.js